// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3gqOU","list":"BalanceDue_list__3dkd2","listRow":"BalanceDue_listRow__3M9-t","total":"BalanceDue_total__rFC_v"};